export enum SourceTypeDatabaseEnum {
  'S&P',
  'D&B',
  'Illion',
  'EMIS',
}
